import React from 'react';
import { Form, Button, DatePicker } from 'antd';
import { Localize } from 'components/service';
import moment from 'moment';



const GraphicPackingFiltersForm = ({ action, setCount, setFilters, setFilterList, filterList, gqlBuilderWhere, graphicPackingFilters }) => {


    const initialDate = (date, fieldName) => {
        if (date && date[ fieldName ] && date[ fieldName ].value)
        {
            return moment(date[ fieldName ].value);
        }
        return undefined;
    }

    return (
        <div className="ant-form ant-form-vertical filters-form">
            <Form.Item
                initialValue={ initialDate(graphicPackingFilters, 'startBuildAt') }
                name="startBuildAt"
                label={ <Localize>FORMS.Input_Label_ConstructionStarts</Localize> }
            >
                <DatePicker
                    format="DD.MM.YYYY"
                    style={ { width: '100%' } }
                    placeholder={ Localize({ children: "FORMS.Input_Placeholder_StartDate" }).props.children }
                    onChange={ (date, dateString) =>
                        date ?
                            setFilterList({
                                ...filterList,
                                startBuildAt: {
                                    column: "START_BUILD_AT",
                                    operator: "LIKE",
                                    value: date.format('YYYY-MM-DD') + '%'
                                }
                            }) : setFilterList({
                                ...filterList,
                                startBuildAt: {}
                            }) }
                />
            </Form.Item>

            <Form.Item
                initialValue={ initialDate(graphicPackingFilters, 'startEventAt') }
                name="startEventAt"
                label={ <Localize>FORMS.Input_Label_ExhibitionStarts</Localize> }
            >
                <DatePicker
                    format="DD.MM.YYYY"
                    style={ { width: '100%' } }
                    placeholder={ Localize({ children: "FORMS.Input_Placeholder_StartDate" }).props.children }
                    onChange={ (date, dateString) =>
                        date ?
                            setFilterList({
                                ...filterList,
                                startEventAt: {
                                    column: "START_EVENT_AT",
                                    operator: "LIKE",
                                    value: date.format('YYYY-MM-DD') + '%'
                                }
                            }) : setFilterList({
                                ...filterList,
                                startEventAt: {}
                            }) }
                />
            </Form.Item>

            <div className="form-btn-holder">
                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={ () => {
                        setFilters(gqlBuilderWhere({ ...graphicPackingFilters, ...filterList }));
                        setCount({ ...graphicPackingFilters, ...filterList });
                        action && action();
                    } }
                >
                    <Localize>FORMS.Button_Text_ApplyFilters</Localize>
                </Button>
                <Button
                    className="ant-btn-secondary bg-light-gray btn-right"
                    htmlType="submit"
                    onClick={ () => {
                        setFilterList({});
                        setCount({});
                        setFilters(gqlBuilderWhere({}));
                        localStorage.removeItem("graphicPackingFilters");
                    } }
                >
                    <Localize>FORMS.Button_Text_ResetFilters</Localize>
                </Button>
            </div>
        </div>
    );
};

export default GraphicPackingFiltersForm;